import "./SuggestionRow.css";
import SuggestionCard from "./SuggestionCard";
import { requestMatch } from '../../premium/requestMatch';
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";


export default function SuggestionRow({ profiles, loading }) {

  const [toast, setToast] = useState("");

  const { t } = useTranslation();

  const cardRefs = useRef([]);

  const scrollToNext = (index) => {

    const nextIndex = index + 1;

    if (cardRefs.current[nextIndex]) {

      cardRefs.current[nextIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    }
  };


  const handleLike = async (profile, index) => {
    try {
      const res = await requestMatch(profile.id);
      if (!res) return;
      const status = res?.data?.status;

      if (status === "matched") {

        setToast(
          t(
            "suggestionRow.matchConfirmed",
            {
              name: profile.name
            }
          )
        );

      }
      else if (status === "already") {

        setToast(
          t(
            "suggestionRow.matchAlreadySent",
            {
              name: profile.name
            }
          )
        );

      }
      else {

        setToast(
          t(
            "suggestionRow.matchSent",
            {
              name: profile.name
            }
          )
        );

      }

      setTimeout(() => setToast(""), 2500);

      scrollToNext(index);

    } catch (err) {
      console.error(err);
    }
  };

  const handlePass = (index) => {
    scrollToNext(index);
  };


  return (
    <div className="suggestion-row">

      {loading && (
        Array.from({ length: 3 }).map((_, index) => (
          <div key={index}>
            <SuggestionCard profile={null} />
          </div>
        ))
      )}


      {!loading && profiles && profiles.length > 0 && (
        profiles.map((profile, index) => (
          <div
            key={profile.id}
            ref={el => cardRefs.current[index] = el}
          >
            <SuggestionCard
              profile={profile}
              onLike={() => handleLike(profile, index)}
              onPass={() => handlePass(index)}
            />
          </div>
        ))
      )}


      {!loading && profiles && profiles.length === 0 && (
        <div className="no-suggestions">
          {t("suggestionRow.noSuggestions")}
        </div>
      )}


      {toast && (

        <div className="share-success-toast">

          <div className="share-success-icon">
            ✓
          </div>

          <div>
            <p>
              {toast}
            </p>
          </div>

        </div>

      )}

    </div>
  );
}
